// extracted by mini-css-extract-plugin
export var button = "_l8-0";
export var donut = "_l8-1";
export var donutFill = "_l8-3";
export var donutTrack = "_l8-2";